import $ from 'jquery';

$('.youtube__button').on('click', function (e) {
    e.preventDefault();

    if($(this).siblings('.youtube__checkbox').prop('checked')) {
        sessionStorage.setItem('accept-youtube', 1);
    }

    $('.youtube').each(function () {
        var iframe = document.createElement('iframe');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('src', 'https://www.youtube-nocookie.com/embed/' + $(this).data('embed') + '?rel=0&showinfo=0');
        $(this).html(iframe);
    });
});

if(sessionStorage.getItem('accept-youtube') === '1') {
    $('.youtube__button').trigger('click');
}

if (typeof consentApi !== 'undefined') {
    consentApi.on('enable:marketing', _ => {
        $('.youtube__button').trigger('click');
    });
}
